import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-course-preview-dialog',
  imports: [MatIcon, TranslocoPipe],
  templateUrl: './course-preview-dialog.component.html',
})
export class CoursePreviewDialogComponent {
  protected data = inject<{
    subscriptionId: string;
    courseId: string;
    lang: string;
  }>(MAT_DIALOG_DATA);
  protected readonly translocoService = inject(TranslocoService);
  protected dialogRef =
    inject<MatDialogRef<CoursePreviewDialogComponent>>(MatDialogRef);
  protected readonly sanitizer = inject(DomSanitizer);
  protected readonly http = inject(HttpClient);

  safeUrl: SafeResourceUrl;
  baseUrl = environment.backendConfig.baseUrl;

  constructor() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `${this.baseUrl}/subscriptions/${this.data.subscriptionId}/courses/${this.data.courseId}/preview/${this.data.lang}/story.html`,
    );
  }

  onCloseBtnClick() {
    this.dialogRef.close();
  }
}
